/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightDownIcon24Regular = forwardRef('ArrowDCornerRightDownIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M15.875 7A3.875 3.875 0 0 0 12 3.125H3a.875.875 0 1 0 0 1.75h9c1.174 0 2.125.951 2.125 2.125v11.887l-5.256-5.256A.875.875 0 0 0 7.63 14.87l5.504 5.503a2.637 2.637 0 0 0 3.73 0l5.504-5.503a.875.875 0 1 0-1.238-1.238l-5.256 5.257V7Z" })));
});
